import { apiClient } from "./apiClient";

export const treatmentsApi = {
  listCatalog: () => apiClient.get("/treatments").then((r) => r.data),
  /*
   * Add one this account uses that the catalogue does not have (#398).
   *
   * withdrawal_period_days is required by the CALLER, not defaulted here.
   * The column is NOT NULL DEFAULT 0 and reports.py prints it in the
   * regulatory treatment report, so a helper that quietly filled in a
   * zero would be the exact hazard the form exists to prevent.
   */
  createTreatment: (payload) =>
    apiClient.post("/treatments", payload).then((r) => r.data),
  log: (hiveId, payload) => apiClient.post(`/hives/${hiveId}/treatment`, payload).then((r) => r.data),
};
